(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ImpegnoDetailController', ImpegnoDetailController);

    ImpegnoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Impegno', 'Decisione', 'Gae', 'Struttura', 'VoceBilancio', 'Utente'];

    function ImpegnoDetailController($scope, $rootScope, $stateParams, previousState, entity, Impegno, Decisione, Gae, Struttura, VoceBilancio, Utente) {
        var vm = this;

        vm.impegno = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:impegnoUpdate', function(event, result) {
            vm.impegno = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
